import { useContext, useEffect, useMemo } from 'react';
import apiClient from '../ApiService/apiClient';
import { AppContext } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';

export const useApiClient = () => {
  const { token } = useContext(AppContext);
  const navigate = useNavigate();

  // Redirect to login if token is missing or invalid
  useEffect(() => {
    if (!token) {
      navigate('/auths/auth-login');
    }
  }, [token, navigate]);

  // Create a memoized wrapper around apiClient so we don't re-create it on every render
  const client = useMemo(() => {
    const instance = apiClient;

    instance.interceptors.request.use(config => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        delete config.headers.Authorization;
      }
      return config;
    });

    return instance;
  }, [token]);

  return {
    get:    (url, params) => client.get(url, { params }),
    post:   (url, data)   => client.post(url, data),
    put:    (url, data)   => client.put(url, data),
    delete: (url, data)   => client.delete(url, { data }),
  };
};
